export default __webpack_public_path__ + "static/media/BGL.7ca11e89.png";